<template>
  <div class="TreeProjectComponent">

    <p>{{lang.infotext_1}}</p>
    <b-form-input id="input-search" v-model="searchString" :placeholder="lang.placeholder_Search"></b-form-input>
    <br>
    <ul v-if="isData"  :id="id" class="library_ul">
      <ItemTreeProject :action="action" :lang="lang.TreeItem" :searchString="searchString"  class="item"   :model="dataProjectTree"  :edit="iscategory" ></ItemTreeProject>
    </ul>
    <LoaderComponent  v-if="!isData"></LoaderComponent>

 </div>
</template>

<script>
import ItemTreeProject from "@/components/shared/ItemTreeProject"
import LoaderComponent from "@/components/shared/LoaderComponent"
import { mapGetters } from 'vuex'


export default {
  name: 'TreeProjectComponent',
  components: {
    ItemTreeProject,
    LoaderComponent
  },
  props:{
      iscategory: Boolean,
      reloadTree: Boolean,
      lang: Object,
      action: Boolean
  },
  data: function () {
      return {
          open: true,
          dataItem:{},

          id: "tree_"+this._uid,
          name:'',
          searchString: ""

      };
  },
  computed: {

    ...mapGetters({
      dataProjectTree: 'dataProjectTree',
      reloadAfterDeleteTreeProjectItem: 'reloadAfterDeleteTreeProjectItem',
      
    }),
    isData(){


      return this.$store.getters.dataProjectTree.name != ""
    }
  },
  watch: {
         
    reloadAfterDeleteTreeProjectItem: function()
    {
      this.loadData();
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeProjectItem",false )
      
    },

    reloadTree: function()
    {
      this.loadData();
    }
  },
  mounted () {
    
    
  },
  created () {
    

    this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteProjectCategoryMapping");

    this.loadData();

    //this.setCategory();
  },
  updated() {
    
  },
  methods: {
    loadData(){
      
       this.$store.dispatch(this.$store.getters.sectionPrefix + '_getProjectCategories', this.id);
    }

  }
}
</script>


<style lang="scss">

  .library_bold {
    font-weight: bold;
  }

  .library_ul label{
    margin-right: 0px;
  }
  .library_li{
    margin-top: 5px;
    margin-left: 0px;
    width: 100%;

  }
  .library_img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
    margin-left: 5px;
  }
  .library_ul {
    padding-left: 18px;
    line-height: 1.5em;
    list-style-type: none;

  }


</style>



// WEBPACK FOOTER //
// src/components/shared/TreeProjectComponent.vue